import * as React from "react";
import { Upload } from "../models/upload";
import { UploadList } from "./UploadList";
import {
  loadResourceUploads,
  uploadFile,
  deleteResourceUpload
} from "../services/fileUpload";

export interface Props {
  resource: number;
  canDelete: boolean;
  canUpload: boolean;
}

export interface State {
  uploads: Upload[];
}

export class Uploader extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      uploads: []
    };

    this.uploadFile = this.uploadFile.bind(this);
    this.refresh = this.refresh.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  public componentDidMount() {
    this.refresh();
  }

  public render() {
    let uploads = this.state.uploads;
    return (
      <div>
        <UploadList
          uploads={uploads}
          deleteUpload={this.props.canDelete ? this.deleteFile : undefined}
        />
        {this.props.canUpload ? (
          <input id="files" type="file" onChange={this.uploadFile} />
        ) : (
          undefined
        )}
      </div>
    );
  }

  private deleteFile(uploadId: number) {
    deleteResourceUpload(this.props.resource, uploadId).then(() => {
      this.setState(prevState => {
        let uploads = prevState.uploads.filter(u => u.id !== uploadId);
        return {
          uploads
        };
      });
    });
  }

  private uploadFile(event: React.ChangeEvent<HTMLInputElement>) {
    if (!event.target.files) {
      return;
    }

    let file = event.target.files[0];

    uploadFile(file, this.props.resource).subscribe(
      upload => {
        this.setState(prevState => {
          let uploads = [...prevState.uploads];
          let index = uploads.findIndex(u => u.id == upload.id);
          if (index >= 0) {
            uploads[index] = upload;
          } else {
            uploads.push(upload);
          }
          return {
            uploads
          };
        });
      },
      error => console.error(error)
    );
  }

  private refresh() {
    loadResourceUploads(this.props.resource).then((uploads: Upload[]) => {
      this.setState({
        uploads: uploads
      });
    });
  }
}
